__turbopack_context__.v({
  "container": "Map-module__yelXAG__container",
  "containerPoster": "Map-module__yelXAG__containerPoster",
  "containerRound": "Map-module__yelXAG__containerRound",
});
